/**
 * Rounding number to two decimal places to a specified precision.
 *
 * @param {string} value - The number string to round.
 * @returns {string} - The rounded number string with two decimal places.
 */
function roundNumber(value: string, precision: number): string {
   if (/^\d+\.\d{3,}$/.test(value)) {
      return parseFloat(value).toFixed(precision);
   }
   return value;
}

/**
 * Rounds numbers in an array of objects to a specified precision.
 *
 * @param {Array<Record<string, any>>} dataList The array of objects to process.
 * @param {number} precision The precision to which numbers should be rounded.
 * @returns {Array<Record<string, any>>} A new array of objects with rounded numbers.
 */
export function roundNumbersInListTable(
   dataList: Array<Record<string, any>>,
   precision: number
): Array<Record<string, any>> {
   return dataList.map((obj) => {
      const newObj = { ...obj };
      for (const key in newObj) {
         if (typeof newObj[key] === "string") {
            newObj[key] = roundNumber(newObj[key], precision);
         } else if (typeof newObj[key] === "object" && newObj[key] !== null) {
            for (const subKey in newObj[key]) {
               if (typeof newObj[key][subKey] === "string") {
                  newObj[key][subKey] = roundNumber(newObj[key][subKey], precision);
               }
            }
         }
      }
      return newObj;
   });
}
